module.exports = "<ng-container *ngFor=\"let template of templates\">\n    <ng-container *ngTemplateOutlet=\"template\"></ng-container>\n</ng-container>\n"